import { useState } from 'react';
import { Container, Load } from './styled';
import { toast } from 'react-toastify';
import { Avatar } from '../../../../../../components';
import { useVideoCall } from '../../../../../../contexts/videoCall';


export function Item(props) {

    const { customer, user } = props;
    const { inviteUserSystem } = useVideoCall();
    const [loading, setLoading] = useState(false);


    async function handInvite(user) {
        setLoading(true)
        const success = await inviteUserSystem({ guestUser: user, rootCustomer: customer })
        if (success) {
            toast.success('Convite enviado com sucesso', { position: "top-right", autoClose: 5000, });
        } else {
            toast.error('Error ao enviar convite', { position: "top-right", autoClose: 5000, });
        }
        setLoading(false)
    };


    return (
        <Container key={user.id} isLoading={loading ? 1 : 0}>
            <Avatar name={user.nomecompleto} width={'2rem'} height={'2rem'} fontSize={'1rem'} />
            <div className='info'>
                <span>
                    {user.nomecompleto}
                </span>
                <div className='actions'>
                    <button onClick={() => handInvite(user)}>
                        {!loading
                            ? <>Convidar</>
                            : <Load />
                        }
                    </button>
                </div>
            </div>
        </Container>
    );
}           